/* global SubmitEvent */

import delegateListener from '../modules/delegate-listener';
import { openInNewWindow, triggerEvent } from '../modules/dom-helpers';
import Delivery from '../api/delivery';
import FormHelper from '../modules/form-helper';

import TemplateHelper from '../modules/template-helper';
const templateHelper = new TemplateHelper();

class OrderDelivery {
  constructor(options = {}) {
    const defaults = {
      enabledPages: '.page--order-delivery, .page--pricing',
      formSelector: '#delivery-order-images',
      deliveryFormID: 'order-delivery-form',
      checkboxSelector: '.image-grid__checkbox',
      counterSelector: '[data-count-selections]',
      selectSelector: '#order_delivery__towing__assignee',
      cancelSelector: '[data-cancel-delivery]',
      submitSelector: '#order-delivery-submit'
    };

    Object.assign(this, defaults, options);
  }

  init() {
    if(!document.querySelector(this.enabledPages)) return; // break early if page is not in enabled list

    this._form = document.querySelector(this.formSelector);
    if(this._form) {
      this._counter = this._form.querySelector(this.counterSelector);
      this._checkboxes = this._form.querySelectorAll(this.checkboxSelector);
      addEventListener('change', delegateListener(
        this.checkboxSelector, this._handleCheckboxChange.bind(this)
      ));
    }

    if(document.querySelectorAll('.page--order-delivery')) {
      document.body.addEventListener('click', delegateListener(
        '[data-target="new-window"]', this._handlePricingPopupLink.bind(this)
      ));
      addEventListener('message', this._handleSelectWarehouseMessage.bind(this));
    }

    if(document.querySelectorAll('.page--pricing')) {
      document.body.addEventListener('click', delegateListener(
        '[data-select-warehouse]', this._handleSelectWarehouseClick.bind(this)
      ))
    }

    if(document.querySelectorAll(this.cancelSelector)) {
      document.body.addEventListener('click', delegateListener(
        this.cancelSelector, this._handleCancelDelivery.bind(this)
      ));
    }

    // Fix faux submit button behavior by manually triggering a submit event:
    if(document.querySelector(this.submitSelector)) {
      document.querySelector(this.submitSelector).addEventListener('click', event => {


        const { form } = event.currentTarget;
        if(!form) return;
        const submitEvent = new SubmitEvent('submit', {
          submitter: event.currentTarget,
          bubbles: true
        });
        form.dispatchEvent(submitEvent);
      });
    }
  }

  /**
   * Updates the thumbnail list of images selected to be visible
   * in the delivery order.
   * @param {Array} itemImages - Updated list of images for this item
   */
  updateSelectedImages(itemImages) {
    const imagesHTML = templateHelper.render('thumblist', {
      images: itemImages.filter(image => image.showInDeliveryOrder)
    }, null, 'none');
    const thumbsContainer = document.querySelector('.js-delivery-thumblist');
    thumbsContainer.parentElement.innerHTML = imagesHTML;
    // Close the modal once done
    const closeButton = document.querySelector('.modal--open button[data-modal-close]');
    triggerEvent(closeButton, 'click');
  }

  /**
   * Button click handler for canceling the current delivery order.
   * Expects a data-cancel-delivery="{{delivery_pid}}" attribute on the button.
   *
   * @param {Object} event - The initiating event
   */
  _handleCancelDelivery(event) {
    const button = event.delegateTarget || event.target;
    const deliveryPid = button.dataset.cancelDelivery;
    if(deliveryPid) {
      const delivery = new Delivery(deliveryPid);
      delivery.remove().then(response => {
        if(response.status === 'OK') {
          window.location.href = window.ITEM_VIEW_URL;
        } else {
          new FormHelper()._updateMessages(document.getElementById(this.deliveryFormID), response.messages, false);
        }
      });
    }
  }

  _handleCheckboxChange(event) {
    this.updateCheckedCount();
  }

  updateCheckedCount() {
    const checkedCount = this._countCheckedCheckboxes();
    this._counter.innerHTML = checkedCount;
  }

  _countCheckedCheckboxes() {
    return Array.from(this._checkboxes).reduce((result, checkbox) => {
      return result + (checkbox.checked ? 1 : 0);
    }, 0)
  }

  /**
   * Click handler for pricing page's warehouse selection buttons
   * Sends a message event containing the selected warehouse's PID to the parent window (i.e. order delivery view)
   *
   * @param {Object} event - The click event object
   */
  _handleSelectWarehouseClick(event) {
    const button = event.delegateTarget || event.target;
    const warehouseId = button.dataset.selectWarehouse;
    const parentWindow = window.opener;

    if(parentWindow && warehouseId) {
      parentWindow.postMessage({
        warehouse: warehouseId
      });

      window.close();
    }
  }

  /**
   * Message handler for pricing page's warehouse selection buttons
   * Selects the warehouse specified by the message's data, then triggers a change event (for prefill module)
   *
   * @param {Object} event - The message event object
   */
  _handleSelectWarehouseMessage(event) {
    if(event.data.warehouse) {
      const select = document.querySelector(this.selectSelector);
      select.value = event.data.warehouse;
      triggerEvent(select, 'change');
    }
  }

  /**
   * Click handler for links that should open into a popup window
   *
   * @param {Object} event - The click event object
   */
  _handlePricingPopupLink(event) {
    event.preventDefault();
    openInNewWindow(event.delegateTarget.href);
  }
}

module.exports = OrderDelivery;
